import { Component } from '@angular/core';
import { MagliveApiClient } from "src/lib/api-client/maglive-api-client";

@Component({
  selector: 'maglive-admin-profile-remove',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './profile-remove.component.scss'],
  templateUrl: './profile-remove.component.html'
})
export class ProfileRemoveComponent {

  removeProfileUserId: string;
  removeProfileUserIconURL: string;
  removeProfileUserNickname: string;

  reloadRemoveUserProfiles(userId: number | null) {
    if (userId === null) {
      return;
    }
    this.removeProfileUserIconURL = MagliveApiClient.getUserIconURL(userId);
    MagliveApiClient.getUserProfile(userId).subscribe(x => {
      if (x === 'NOT_AUTHORIZED') {
        return;
      } else if (x === "NOT_FOUND") {
        this.removeProfileUserNickname = '';
      } else {
        this.removeProfileUserNickname = x.nickname
      }
    })
  }

  removeUserProfile() {
    if (this.removeProfileUserId === null || this.removeProfileUserId === "" || isNaN(parseInt(this.removeProfileUserId, 10))) {
      console.error(this.removeProfileUserId);
      return; // TODO show error
    }
    MagliveApiClient.removeUserProfile(parseInt(this.removeProfileUserId, 10)).subscribe(_ => {
      this.removeProfileUserNickname = '';
    })
  }

  removeUserIcon() {
    if (this.removeProfileUserId === null || this.removeProfileUserId === "" || isNaN(parseInt(this.removeProfileUserId, 10))) {
      console.error(this.removeProfileUserId);
      return; // TODO show error
    }
    const userId = parseInt(this.removeProfileUserId, 10);
    MagliveApiClient.removeUserIcon(userId).subscribe(_ => {
      this.reloadRemoveUserProfiles(userId);
    })
  }
}
